/* Packages */
import React, {lazy, Suspense} from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDatasetToProps} from "../../parseDatasetToProps";

/* Components */
const ConversionFlow = lazy(() => import(/* webpackChunkName: "ConversionFlow" */ './ConversionFlow'));

/* Render */
const conversionNode = document.getElementById('conversion-flow');
if (conversionNode) {
    const props = parseDatasetToProps(conversionNode.dataset);

    render(
        <Suspense fallback={<></>}>
            <ConversionFlow
                {...props}
            />
        </Suspense>,
        conversionNode
    );
}

const ConversionFlowInPage = lazy(() => import(/* webpackChunkName: "ConversionFlowInPage" */ './ConversionFlowInPage'));

/* Render */
document.querySelectorAll('.conversion-flow-in-page').forEach((node) => {
    const props = parseDatasetToProps(node.dataset);

    render(
        <Suspense fallback={<></>}>
            <ConversionFlowInPage {...props} />
        </Suspense>,
        node
    );
});
